import { Center, Group, Loader, Stack, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ClientConnectionItem, clientConnections, useBot } from '@mygpt/app';
import ContainerHeader from '@/components/Headers/ContainerHeader';
import { useNotification } from '@/components/Notification/hooks';
import VisitorTable from '@/components/Visitors/VisitorTable';

const Visitors = () => {
  const { t } = useTranslation();

  const { botId } = useBot();
  const location = useLocation();
  const { state } = location;
  const { setVisitorList, visitorList } = useNotification();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<ClientConnectionItem[]>([]);

  const initData = async () => {
    await clientConnections({ aiId: botId })
      .then((rsp) => {
        const list = rsp.data;
        setData(list);
        setVisitorList(list); // 当直接在当前页面刷新时重新设置store
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    initData();
  }, []);

  // 当接受到通知且有变化时
  useEffect(() => {
    if (data.length !== visitorList.length) initData();
  }, [visitorList.length]);

  return (
    <>
      <ContainerHeader title={t('visitors.title')} description={t('visitors.desc')} />
      {loading ? (
        <Center mt={50}>
          <Loader />
        </Center>
      ) : (
        <Stack>
          {data.length ? (
            <>
              <Group justify="space-between">
                <Text size={'md'} fw={500}>
                  {t('visitors.active')} ({data.length})
                </Text>
              </Group>
              <VisitorTable data={data} highlightedId={state?.connectionId} />
            </>
          ) : (
            <Center mt={100}>
              <Text color="gray.4">{t('no_data_visitors')}</Text>
            </Center>
          )}

          {/* <Group justify="space-between">
            <Pagination
              page={1}
              size={'sm'}
              onChange={(value) => {
                console.log(value);
              }}
              total={1}
              color="violet.5"
            />
            <Text size={'sm'}>Total {data.length} items</Text>
          </Group> */}
        </Stack>
      )}
    </>
  );
};

export default Visitors;
